export default __webpack_public_path__ + "static/media/robot.2e6b7b0a.svg";